import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import {
  getNotifications,
  getNotificationsError,
  getNotificationsSuccess,
  restoreNotificationsError,
  restoreNotificationsSuccess,
  updateNotificationsError,
  updateNotificationsSuccess,
} from './actions'
import {
  GET_NOTIFICATIONS_ASYNC,
  RESTORE_NOTIFICATIONS_ASYNC,
  UPDATE_NOTIFICATIONS_ASYNC,
} from './constants'

const getNotificationsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, GET_NOTIFICATIONS_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.customizationO365)
      return true
    }),
    switchMap((action) =>
      api.settings
        .getNotifications(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload?.locale || ''
        )
        .pipe(
          map((response) => getNotificationsSuccess(response)),
          catchError((error) => of(epicsErrorHandler(getNotificationsError, error))),
          takeUntil(action$.pipe(ofType(GET_NOTIFICATIONS_ASYNC.CANCEL)))
        )
    )
  )

const updateNotificationsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_NOTIFICATIONS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .updateNotifications(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.data,
          action.payload.locale || ''
        )
        .pipe(
          mergeMap(() => of(updateNotificationsSuccess(), getNotifications(action.payload.locale))),
          catchError((error) => of(epicsErrorHandler(updateNotificationsError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_NOTIFICATIONS_ASYNC.CANCEL)))
        )
    )
  )

const restoreNotificationsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(RESTORE_NOTIFICATIONS_ASYNC.INITIATE),
    mergeMap((action) =>
      api.settings
        .restoreNotifications(
          state$.value.partnerOptions.selectedCompany?.value,
          action.payload.locale || ''
        )
        .pipe(
          mergeMap(() =>
            of(restoreNotificationsSuccess(), getNotifications(action.payload.locale))
          ),
          catchError((error) => of(epicsErrorHandler(restoreNotificationsError, error))),
          takeUntil(action$.pipe(ofType(RESTORE_NOTIFICATIONS_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getNotificationsEpic, updateNotificationsEpic, restoreNotificationsEpic)
